module.exports = __webpack_public_path__ + "img/fire_tool_2.767dbafa.png";